module.exports = __webpack_public_path__ + "static/img/icon-prehospay.5f09da1.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/icon-prehospay.png
// module id = M8GT
// module chunks = 15